import { Provider } from '@angular/core';
import { environment } from 'src/environment/environment';
import { MachineApi } from './machine.api';
import { TypeDataApi } from './type-data.api';
import { API_BASE_URL, UM_BASE_URL, US_BASE_URL } from './tokens';
import { FilterApi } from './filterApi';

export const apiProviders: Provider[] = [
  MachineApi,
  TypeDataApi,
  FilterApi,
  { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
  { provide: US_BASE_URL, useValue: environment.usBaseUrl },
  { provide: UM_BASE_URL, useValue: environment.umBaseUrl },
];
